import { useEffect, useState } from "react";
import axios from "axios";
import { PRODUCTS as SEED, getCategoryLabel } from "@/data/products";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Normalize a product doc from API to the shape the UI expects
function normalize(p) {
  const variant_prices = p.variant_prices || {};
  // If sizes were wiped but variant_prices exist, use variant_prices keys as sizes
  const sizes = (p.sizes && p.sizes.length > 0)
    ? p.sizes
    : Object.keys(variant_prices);
  return {
    slug: p.slug,
    name: p.name,
    category: p.category,
    tagline: p.tagline || "",
    short: p.short,
    image: p.image,
    sizes,
    packaging: p.packaging || "",
    price: p.price || "",
    variant_prices,
    benefits: p.benefits || [],
    howTo: p.how_to || p.howTo || [],
    specs: p.specs || {
      "Available Sizes": sizes.join(" · "),
      "Packaging": p.packaging || "",
      "Country Of Origin": "India",
    },
    faq: p.faq || [],
  };
}

export function useProducts() {
  const [products, setProducts] = useState(SEED);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    const load = () => {
      axios.get(`${API}/products`)
        .then(({ data }) => {
          if (!alive) return;
          const list = (data.products || []).map(normalize);
          if (list.length > 0) setProducts(list);
        })
        .catch(() => {})
        .finally(() => { if (alive) setLoading(false); });
    };
    load();
    const onFocus = () => load();
    const onVisibility = () => { if (document.visibilityState === "visible") load(); };
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisibility);
    return () => {
      alive = false;
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, []);
  return { products, loading };
}

export function useProduct(slug) {
  const [product, setProduct] = useState(() => SEED.find(p => p.slug === slug) || null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    const load = () => {
      axios.get(`${API}/products/${slug}`)
        .then(({ data }) => { if (alive) setProduct(normalize(data)); })
        .catch(() => {})
        .finally(() => { if (alive) setLoading(false); });
    };
    load();
    const onFocus = () => load();
    window.addEventListener("focus", onFocus);
    return () => { alive = false; window.removeEventListener("focus", onFocus); };
  }, [slug]);
  return { product, loading };
}

export { getCategoryLabel };
